import React, { useEffect, useState } from "react";
import { Wrapper } from "./style";
import Config from "../../utils/config";
import { Heading, ButtonSolid, TableWarpper, Text } from "../styledConstants";
import MaterialInput from "../common/UI/MaterialInput";
import Request from "../../utils/Request";
import { toast } from "react-toastify";
import Pagination from "../common/Pagination";
import ItemPerPage from "../common/ItemPerPage";
import { FilterWrapper } from "../../Pages/Merchants/style";
import FilterBox from "../common/FilterBox";
import { CSVLink } from "react-csv";

const filterForm = [
    {
        name: "mccCode",
        type: "text",
        placeholder: "MCC Code",
        value: "",
    },
    {
        name: "mccDesc",
        type: "text",
        placeholder: "MCC Description",
        value: "",
    }
];

const mccHeaders = [
    { label: "MCC Code", key: "mccCode" },
    { label: "MCC Description", key: "mccDesc" },
    { label: "NIC Code", key: "nic" },
    { label: "NIC Description", key: "nicDesc" },
    { label: "HSN Code", key: "hsn" },
    { label: "HSN Description", key: "hsnDesc" },
    { label: "Industry Group", key: "industryGroup" },
];

export default function ViewMCCList() {
    const mccTypes = ["UDYAM", "MUNICIPAL", "GST"];

    const [selectedMCCType, setSelectedMCCType] = useState('UDYAM');
    const [mccList, setMccList] = useState([]);
    const [filteredMccList, setFilteredMccList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [controls, setControls] = useState([...filterForm]);
    const [filters, setFilters] = useState({
        mccCode: "",
        mccDesc: ""
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [filtersApplied, setFiltersApplied] = useState(false);

    useEffect(() => {
        fetchMccList();
    }, [selectedMCCType])

    useEffect(() => {
        if (mccList.length > 0) {
            applyFilters();
        }
    }, [mccList, currentPage, pageSize]);

    useEffect(() => {
        if (filtersApplied && mccList.length > 0) {
            applyFilters();
        }
    }, [filters]);

    const fetchMccList = () => {
        const successHandler = (res) => {
            console.log("res: ", res);
            if (res.data && Array.isArray(res.data)) {
                setMccList(res.data);
                setCurrentPage(1);
                setFiltersApplied(false);
            } else {
                setMccList([]);
                setFilteredMccList([]);
                toast.error("No data found");
            }
            setLoading(false);
        };
        const errorHandler = (error) => {
            setLoading(false);
            toast.error("Failed to fetch MCC list");
            console.error("Error fetching MCC list:", error);
        };
        setLoading(true);
        const api = new Request("", successHandler, errorHandler, false);
        return api.get(`${Config.apis.user.MCC_LIST}?type=${selectedMCCType}`);
    };

    const handleMCCTypeChange = (type) => {
        setSelectedMCCType(type);
        setCurrentPage(1);
        // Reset filters and controls when type changes
        const resetFilters = { mccCode: "", mccDesc: "" };
        setFilters(resetFilters);
        setControls(controls.map(control => ({
            ...control,
            value: ""
        })));
        setFiltersApplied(false);
    };

    const FilterChangeHandler = (event, index) => {
        console.log("event, index", event, index);
        const _controls = [...controls];

        if (event?.target) {
            _controls[index].value = event.target.value;
        }
        else {
            _controls[index].value = event;
        }

        setControls(_controls);
    };

    const updateFiltersFromControls = (controlsArray = controls) => {
        const newFilters = {};
        controlsArray.forEach(control => {
            newFilters[control.name] = control.value;
        });
        setFilters(newFilters);
    };

    const applyFilters = () => {
        if (!mccList.length) {
            setFilteredMccList([]);
            setTotalPages(1);
            return;
        }

        console.log("Applying filters:", filters);
        console.log("Total records to filter:", mccList.length);

        let filteredData = mccList.filter(item => {
            const matchesMccCode = !filters.mccCode ||
                (item.mccCode && item.mccCode.toString().toLowerCase().includes(filters.mccCode.toLowerCase()));

            const matchesMccDesc = !filters.mccDesc ||
                (item.mccDesc && item.mccDesc.toLowerCase().includes(filters.mccDesc.toLowerCase()));

            return matchesMccCode && matchesMccDesc;
        });

        console.log("Filtered records:", filteredData.length);

        // Update total pages based on filtered data
        const totalPagesCount = Math.ceil(filteredData.length / pageSize);
        setTotalPages(totalPagesCount);

        // Ensure current page is within bounds after filtering
        const validCurrentPage = Math.min(currentPage, Math.max(1, totalPagesCount));
        if (validCurrentPage !== currentPage) {
            setCurrentPage(validCurrentPage);
        }

        // Get data for current page
        const startIndex = (validCurrentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const currentData = filteredData.slice(startIndex, endIndex);

        setFilteredMccList(currentData);
    };

    const searchAdmin = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        updateFiltersFromControls();
        setCurrentPage(1);
        setFiltersApplied(true);
        toast.success("Filters applied");
    };

    const refreshPage = () => {
        const resetFilters = { mccCode: "", mccDesc: "" };
        setFilters(resetFilters);
        setControls(controls.map(control => ({
            ...control,
            value: ""
        })));
        setCurrentPage(1);
        setFiltersApplied(false);
        applyFilters();
        toast.success("Filters cleared");
        fetchMccList();
    };

    const getTotalFilteredCount = () => {
        if (!mccList.length) return 0;

        return mccList.filter(item => {
            const matchesMccCode = !filters.mccCode ||
                (item.mccCode && item.mccCode.toString().toLowerCase().includes(filters.mccCode.toLowerCase()));

            const matchesMccDesc = !filters.mccDesc ||
                (item.mccDesc && item.mccDesc.toLowerCase().includes(filters.mccDesc.toLowerCase()));

            return matchesMccCode && matchesMccDesc;
        }).length;
    };

    const getMCCHeaders = (selectedType) => {
        const baseHeaders = [
            { label: "MCC Code", key: "mccCode" },
            { label: "MCC Description", key: "mccDesc" },
        ];

        switch (selectedType) {
            case 'UDYAM':
                return [
                    ...baseHeaders,
                    { label: "NIC Code", key: "nic" },
                    { label: "NIC Description", key: "nicDesc" },
                    { label: "Industry Group", key: "industryGroup" },
                ];
            case 'GST':
                return [
                    ...baseHeaders,
                    { label: "HSN Code", key: "hsn" },
                    { label: "HSN Description", key: "hsnDesc" }
                ];
            case 'MUNICIPAL':
                return [
                    ...baseHeaders,
                    { label: "Industry Group", key: "industryGroup" },
                ];
            default:
                return baseHeaders;
        }
    };
    return (
        <Wrapper>
            <div className="flex flex-center space-between mb10">
                <Heading size="xxl" className="mt32">View MCC List</Heading>
            </div>

            <div className="mcc-type-selector mb20">
                <div className="flex flex-center gap16">
                    {mccTypes.map((type) => (
                        <button
                            key={type}
                            className={`type-button ${selectedMCCType === type ? 'active' : ''}`}
                            onClick={() => handleMCCTypeChange(type)}
                        >
                            {type}
                        </button>
                    ))}
                </div>
            </div>

            <FilterWrapper>
                <FilterBox
                    filterForm={controls}
                    onFilterChange={FilterChangeHandler}
                    onFilterSubmit={searchAdmin}
                    refreshPage={refreshPage}
                    className="transactionfilter"
                    preventDefault={true}
                />


                <div className="download-button-container">
                    <CSVLink
                        headers={getMCCHeaders(selectedMCCType)}
                        data={mccList}   // use currentData if only paginated rows needed
                        filename="mcclist.csv"
                    >
                        <ButtonSolid width="150px" type="button" primary xl className="col">
                            Download CSV
                        </ButtonSolid>
                    </CSVLink>
                </div>
            </FilterWrapper>

            {loading && (
                <div className="loading-container">
                    <div className="loading-spinner">Loading...</div>
                </div>
            )}

            {!loading && filteredMccList.length > 0 && (
                <>
                    <TableWarpper className="mt24">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-left">
                                        <Text size="rg" color="color7" fw="medium">
                                            MCC Code
                                        </Text>
                                    </th>
                                    <th className="text-left">
                                        <Text size="rg" color="color7" fw="medium">
                                            MCC Description
                                        </Text>
                                    </th>

                                    {selectedMCCType === 'UDYAM' && (
                                        <>
                                            <th className="text-left">
                                                <Text size="rg" color="color7" fw="medium">
                                                    NIC Code
                                                </Text>
                                            </th>
                                            <th className="text-left">
                                                <Text size="rg" color="color7" fw="medium">
                                                    NIC Description
                                                </Text>
                                            </th>
                                        </>
                                    )}

                                    {selectedMCCType === 'GST' && (
                                        <>
                                            <th className="text-left">
                                                <Text size="rg" color="color7" fw="medium">
                                                    HSN Code
                                                </Text>
                                            </th>
                                            <th className="text-left">
                                                <Text size="rg" color="color7" fw="medium">
                                                    HSN Description
                                                </Text>
                                            </th>
                                        </>
                                    )}

                                    {(selectedMCCType === 'UDYAM' || selectedMCCType === 'MUNICIPAL') && (
                                        <th className="text-left">
                                            <Text size="rg" color="color7" fw="medium">
                                                Industry Group
                                            </Text>
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredMccList.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {item?.mccCode || "-"}
                                            </Text>
                                        </td>
                                        <td>
                                            <Text size="xsm" color="#828282">
                                                {item?.mccDesc || "-"}
                                            </Text>
                                        </td>

                                        {selectedMCCType === 'UDYAM' && (
                                            <>
                                                <td>
                                                    <Text size="xsm" color="#828282">
                                                        {item?.nic || "-"}
                                                    </Text>
                                                </td>
                                                <td>
                                                    <Text size="xsm" color="#828282">
                                                        {item?.nicDesc || "-"}
                                                    </Text>
                                                </td>
                                            </>
                                        )}

                                        {selectedMCCType === 'GST' && (
                                            <>
                                                <td>
                                                    <Text size="xsm" color="#828282">
                                                        {item?.hsn || "-"}
                                                    </Text>
                                                </td>
                                                <td>
                                                    <Text size="xsm" color="#828282">
                                                        {item?.hsnDesc || "-"}
                                                    </Text>
                                                </td>
                                            </>
                                        )}

                                        {(selectedMCCType === 'UDYAM' || selectedMCCType === 'MUNICIPAL') && (
                                            <td>
                                                <Text size="xsm" color="#828282">
                                                    {item?.industryGroup || "-"}
                                                </Text>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </TableWarpper>

                    <div className="mt24 flex flex-center space-between">
                        <div className="flex flex-center">
                            <Text size="xsm" color="#828282">
                                Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, getTotalFilteredCount())} of {getTotalFilteredCount()} entries
                            </Text>
                        </div>
                        <div className="flex flex-center gap16">
                            {mccList.length > 1 && (
                                <ItemPerPage
                                    pageSize={pageSize}
                                    getPageSize={(pagesize) => {
                                        setPageSize(pagesize);
                                        setCurrentPage(1);
                                    }}
                                />
                            )}
                            {totalPages > 1 && (
                                <Pagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    getCurrentPageData={(curpage) => {
                                        setCurrentPage(curpage);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </>
            )}

            {!loading && mccList.length === 0 && (
                <div className="empty-state">
                    No MCC data available for {selectedMCCType}
                </div>
            )}

            {!loading && mccList.length > 0 && filteredMccList.length === 0 && (
                <div className="empty-state">
                    No MCC records found matching your filters
                </div>
            )}

        </Wrapper>
    );
}